import { useDispatch, useSelector } from 'react-redux';
import ResponseTimeContent from './ResponseTimeContent';
import ResponseTimeEmptyState from './ResponseTimeEmptyState';
import PerformanceCard from '../PerformanceCard';
import Trans from '@/components/shared/Trans';
import translations from '@/components/Dashboard/Dashboard.trans.json';
import useFetchDashboard from '../../customHooks/useFetchDashboard';
import { getPerformanceResponseTimeCard } from '@/store/slices/components/dashboard/service';
import { setPerformanceModals } from '@/store/slices/components/dashboard/DashboardSlice';

export default function ResponseTime() {
  const dispatch = useDispatch();
  const { responseTime } = useSelector((state) => state.DashboardSlice);
  const { ref, isStale, useFetchOnViewport } = useFetchDashboard();
  const { mdn, max, min, loading, hasFetched } = responseTime;
  const showEmptyState = !mdn && !max && !min;

  useFetchOnViewport(
    (query) => {
      dispatch(getPerformanceResponseTimeCard({ query }));
    },
    [],
    { hasFetched }
  );

  const handleOpenTable = () => {
    dispatch(
      setPerformanceModals({
        key: 'responseTime',
        subkey: 'isOpen',
        value: true,
      })
    );
  };

  return (
    <PerformanceCard ref={ref} loading={loading || isStale} id="response-time">
      <PerformanceCard.Header handleClickTableIcon={handleOpenTable}>
        {Trans(translations, 'MedianResponseTime')}
      </PerformanceCard.Header>
      {showEmptyState ? <ResponseTimeEmptyState /> : <ResponseTimeContent />}
    </PerformanceCard>
  );
}
